import React from "react";

const CautiousIcon = (props: React.ComponentProps<"svg">) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="#F4333F"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="11.9999"
      r="9"
      stroke="#F4333F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="12"
      y="8"
      width="0.01"
      height="0.01"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinejoin="round"
    />
    <path
      d="M12 12V16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CautiousIcon;
